module.exports = __webpack_public_path__ + "static/media/oberflex-poirier-1200x2490.6ab6661c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-poirier-1200x2490.jpg
// module id = 1052
// module chunks = 37